import React, { useEffect, useState } from "react";
import { DatePicker, Select, Tag } from "antd";
import axios from "axios";
import { Card } from "components";
import BarCharts from "modules/Dashboard/components/BarCharts";
import { Option } from "antd/es/mentions";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";

function Product_Detail() {
  const [data, setData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [selectedDataKey, setSelectedDataKey] = useState('amount');
  const [selectedMonth, setSelectedMonth] = useState(dayjs()); 
  const { id } = useParams();

  useEffect(() => {
    getData();
  }, [selectedMonth]); 

  const getData = () => {
    const queryDate = selectedMonth ? selectedMonth.format("YYYY-MM") : null;
    axios({
      method: "get",
      url: `product/${id}`,
      params: { date: queryDate }, 
    })
      .then((res) => {
        setData(res.data);
        let tmp = [];
        res.data.sales.map((item) =>
          tmp.push({
            cnt: item.qty,
            month: item.orderdate,
            amount: item.totalamount,
          })
        );
        setChartData(tmp);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleMonthChange = (value) => {
    setSelectedMonth(value); 
  };

  const handleChange = (event) => {
    setSelectedDataKey(event);
  };

  return (
    <div className="mainCard px-10">
      <div className="border drop-shadow-lg w-full border-gray-200 bg-white py-4 px-6 rounded-3xl mb-10">
        <div className="flex font-sans">
          <div className="flex-none w-[400px] h-[300px] relative mr-4">
            <img
              src={`${process.env.REACT_APP_CDN_URL}${data.image}`}
              alt=""
              className="absolute inset-0 w-full h-full object-cover "
              loading="lazy"
            />
          </div>
          <div className="flex-auto p-6">
            <div className="flex flex-wrap">
              <h1 className="flex-auto text-lg font-semibold text-slate-900">
                Нэр: {data.name}
              </h1>
            </div>
          </div>
        </div>
      </div>

      <Card>
        <div className="flex justify-between items-center mb-6">
          <div className="flex gap-2">
            <h1 className="text-base">Барааны зарагдсан түүх</h1>
            <Select value={selectedDataKey} onChange={handleChange}>
              <Option value="amount">Үнийн дүн</Option>
              <Option value="cnt">Тоо ширхэг</Option>
            </Select>
          </div>

          <div className="flex gap-2 items-center text-[#383838]">
            <DatePicker.MonthPicker
              placeholder="Бүгд"
              className="rounded-xl py-2 px-6"
              onChange={handleMonthChange} 
              value={selectedMonth} 
              defaultValue={dayjs()} 
            />
          </div>
        </div>

        <BarCharts data={chartData} dataKey={selectedDataKey} />
      </Card>
    </div>
  );
}

export default Product_Detail;
